export default function ($scope, $rootScope, $mdSidenav, $mdMedia, AuthenticationService, $location, $translate) {
    $scope.username =  $rootScope.globals.currentUser.username;

    $rootScope.aside  = true;
    $scope.show = true;

    $scope.toggleLeft = function(){
        if(!$mdMedia('gt-sm')) {
            $mdSidenav('left').toggle();
            $rootScope.aside = true;
        }
        else
            $rootScope.aside = !$rootScope.aside;

        $scope.show = $rootScope.aside;
    };

    $scope.logout = function(){
        AuthenticationService.Logout();
        $location.path('/login');
    };
};


/** WEBPACK FOOTER **
 ** ./js/theme/header/controller.js
 **/